import script from "./MakerCartGuide2Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide2Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide2Page.vue?vue&type=style&index=0&id=63797c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63797c96"]])

export default __exports__